import { createActionGroup, props } from '@ngrx/store';
import { DepartmentEntity } from '../../entities/department.entity';
import { UploadActionProps } from '../../guards/resolver.helper';
import {
    DepartmentAddRequest,
    DepartmentDeleteRequest,
    DepartmentEditRequest,
} from '@dave/types/dist/proto/baseService/department';

export const DepartmentActions = createActionGroup({
    source: 'Department',
    events: {
        'Load Success': props<{ Payload: DepartmentEntity[] }>(),
        'Load Request': props<UploadActionProps/*{ Payload?: DepartmentGetRequest }*/>(),
        'Load Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        'Add Success': props<{ Payload: DepartmentEntity }>(),
        'Add Request': props<{ Payload: DepartmentAddRequest }>(),
        'Add Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        'Change Success': props<{ Payload: DepartmentEntity }>(),
        'Change Request': props<{ Payload?: DepartmentEditRequest }>(),
        'Change Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        'Delete Success': props<{ Payload: number }>(),
        'Delete Request': props<{ Payload: DepartmentDeleteRequest }>(),
        'Delete Failure': props<{ Errors: any; ToasterMessage?: string }>(),
    },
});
